import type { ReactElement } from "react";
import { PageMeta } from "@/components/site/PageMeta";

/**
 * Head metadata for internal / non-public routes (admin dashboards, QA
 * harnesses). They still need a self-referencing canonical so crawlers that
 * reach them via a stray link never treat them as a duplicate of another URL,
 * plus an explicit noindex so they stay out of the index entirely.
 *
 * Used from App.tsx so a new admin page cannot ship without head tags.
 */
export function PrivateRoute({
  path,
  title,
  description = "Internal page on DrSullySpeaks.com. Not indexed.",
  children,
}: {
  path: string;
  title: string;
  description?: string;
  children: ReactElement;
}) {
  return (
    <>
      <PageMeta path={path} title={title} description={description} noindex />
      {children}
    </>
  );
}

export default PrivateRoute;
